import { SvgIconProps } from '@mui/material';
import * as React from 'react';

import { ColorProp, usePaletteColor } from '../theme';

export interface IconProps extends TypedOmit<SvgIconProps, 'color'> {
    filled?: boolean;
    color?: ColorProp;
}

interface InnerIconProps extends IconProps {
    iconComponent: React.ComponentType<SvgIconProps>;
    outlineComponent: React.ComponentType<SvgIconProps>;
    roundedComponent: React.ComponentType<SvgIconProps>;
}

export const Icon = React.forwardRef<SVGSVGElement, InnerIconProps>(
    (props, ref) => {
        const {
            color: colorProp = 'action.active',
            iconComponent,
            outlineComponent,
            roundedComponent,
            filled,
            sx,
            width,
            height,
            ...muiProps
        } = props;

        const InnerIcon = filled ? iconComponent : outlineComponent;
        const color = usePaletteColor(colorProp);

        return (
            <InnerIcon
                ref={ref}
                data-role="icon"
                {...(color !== undefined ? { fill: color } : {})}
                sx={{
                    ...(color !== undefined ? { color } : {}),
                    borderRadius: '50%',
                    overflow: 'visible !important',
                    width,
                    height,
                    ...sx
                }}
                {...muiProps}
            />
        );
    }
);
